export const completionPercentage = (
  numberOfCompletedValues,
  totalRequiredValues,
) => {
  return Math.round((numberOfCompletedValues / totalRequiredValues) * 100);
};

/**
 * Creates a unique ID for form values by combining section name and item ID
 * @param {string} sectionName - The name of the section (e.g., 'trusts', 'currentJobs')
 * @param {string} id - The unique identifier for the item
 * @returns {string} - The combined ID in the format `sectionName.id`
 */
export const createFormId = (sectionName, id) => `${sectionName}.${id}`;

/**
 * Maps a field to include a unique ID based on section name and item ID
 * @param {string} sectionName - The name of the section
 * @param {string} id - The unique identifier for the item
 * @param {Object} field - The field object to be mapped
 * @returns {Object} - The field with an added ID property
 */
export const mapIdToFieldForFormValues = (sectionName, id, field) => ({
  id: createFormId(sectionName, id),
  ...field,
});
